// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Confetti {
  text-align: center;
}

.Confetti-particles {
  width: 140px;
  height: 160px;
  display: block;
}

.Confetti-label {
  font-family: 'Passion One', cursive;
  font-size: 64px;
  transition: all 1s cubic-bezier(0, 0, 0.49, 2.32);
  color: rgba(233, 100, 106, 0.68);
}

.Confetti-particle {
  opacity:0;
  position: absolute;
  animation: Confetti 2s ease-in infinite;
}

.Confetti-c1 {
  background-color: rgba(76,175,80,0.5);
}

.Confetti-c2 {
  background-color: rgba(156,39,176,0.5);
}

@keyframes Confetti {
  0% {
    opacity: 0;
    transform:translateY(0%) rotate(0deg);
  }
  10% {
    opacity: 1;
  }
  35% {
    transform:translateY(-800%) rotate(270deg);
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform:translateY(2000%) rotate(1440deg);
  }
}
`, "",{"version":3,"sources":["webpack://./app/confetti.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;EACZ;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,2CAA2C;EAC7C;AACF","sourcesContent":[".Confetti {\n  text-align: center;\n}\n\n.Confetti-particles {\n  width: 140px;\n  height: 160px;\n  display: block;\n}\n\n.Confetti-label {\n  font-family: 'Passion One', cursive;\n  font-size: 64px;\n  transition: all 1s cubic-bezier(0, 0, 0.49, 2.32);\n  color: rgba(233, 100, 106, 0.68);\n}\n\n.Confetti-particle {\n  opacity:0;\n  position: absolute;\n  animation: Confetti 2s ease-in infinite;\n}\n\n.Confetti-c1 {\n  background-color: rgba(76,175,80,0.5);\n}\n\n.Confetti-c2 {\n  background-color: rgba(156,39,176,0.5);\n}\n\n@keyframes Confetti {\n  0% {\n    opacity: 0;\n    transform:translateY(0%) rotate(0deg);\n  }\n  10% {\n    opacity: 1;\n  }\n  35% {\n    transform:translateY(-800%) rotate(270deg);\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    transform:translateY(2000%) rotate(1440deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
